import { h } from 'preact';
import { useEffect } from 'preact/hooks';
import PropTypes from 'prop-types';

import { authStore } from '../../../global-store/subjects/auth';
import { getLabel } from '../../../labels/labelling-service';
import { useRefresh } from '../../hooks/use-refresh';
import { useSubscribe } from '../../hooks/use-subscribe';

import { doWidgetQuery, doWidgetMutations, widgetMutationsSuccessCallback } from './api';
import { getHandlers } from './getters/get-handlers';

const Newsletter = ({
  htmlProps,
  widget,
  state,
  actions,
  pageActions,
  elementIdInPage,
  isActiveInPage,
  render,
  blockInPageType,
}) => {
  useRefresh({ widgetName: widget.name, errorStatus: state.error?.status, errorCode: state.error?.code });
  const authState = useSubscribe(authStore);

  const handlers = getHandlers({ state, actions, widget, pageActions, htmlProps });

  useEffect(() => {
    // First query or after token refresh
    if (authState.userToken && !state.isMutationPending) {
      const listIds = (htmlProps.newsLetters || []).map((newsletter) => newsletter.id);
      if (listIds.length > 0) {
        doWidgetQuery({ widget, listIds, actions });
      } else {
        actions.resetLoader();
      }
    }
    // Mutations after token refresh
    // We launch a query (we do not use subscriptions for newsletters)
    if (authState.userToken && state.isMutationPending) {
      doWidgetMutations({
        widget,
        actions,
        state,
        onSuccessCallback: () => widgetMutationsSuccessCallback({ state, actions, pageActions, widget }),
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [authState.userToken]);

  return render({ htmlProps, state, handlers, elementIdInPage, isActiveInPage, blockType: blockInPageType });
};

Newsletter.propTypes = {
  htmlProps: PropTypes.shape({
    modalUnsubscribe: PropTypes.object,
    footer: PropTypes.object,
    modalTooltip: PropTypes.object,
    description: PropTypes.string,
    title: PropTypes.string.isRequired,
    newsLetters: PropTypes.array.isRequired,
  }),
  widget: PropTypes.shape({
    name: PropTypes.string.isRequired,
    htmlId: PropTypes.string.isRequired,
  }),
  state: PropTypes.object.isRequired,
  actions: PropTypes.object.isRequired,
};

export default Newsletter;
